import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=675b4026&scoped=true&"
import script from "./Leads.vue?vue&type=script&lang=js&"
export * from "./Leads.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=675b4026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b4026",
  null
  
)

export default component.exports